import React, { useContext, useEffect, useState } from 'react';
import { Button, Card } from 'antd';
import IA from '../containers/IA';
import Activity from '../components/Activity';
import { StoreContext } from '../containers/Store';
import * as ROLES from '../constants/roles';

const Chatbot = (props) => {
  const {
    user: {
      user
    },
    tracking: {
      activityId: act
    },
    action: {
      action: acti,
      storeAction
    }
  } = useContext(StoreContext);

  let { activityId } = act;
  if (!activityId) activityId = 0;

  let { action } = acti;
  if (!action) action = 'stop';

  const [button, setButton] = useState(true);

  useEffect(() => {
    if (!button) {
      storeAction({ action: 'go', token: user.token });
    }
  }, [button]);
  
  useEffect(() => {
    return () => storeAction({ action: 'stop', token: user.token })
  }, [])

  const [activityWidth, setActivityWidth] = useState(Math.floor(window.innerWidth*0.6));
  const [activityHeight, setActivityHeight] = useState(Math.floor(window.innerHeight*0.6));

  useEffect(() => {
    if (!!user && user.roles.includes(ROLES.TEACHER_DEMO)) {
      setActivityWidth(Math.floor(window.innerWidth*0.45));
      setActivityHeight(Math.floor(window.innerHeight*0.8));
    } else {
      setActivityWidth(Math.floor(window.innerWidth*0.6));
      setActivityHeight(Math.floor(window.innerHeight*0.6));
    }
  }, [window.innerWidth])
  
  return (
    <div style={{
      display: 'flex',
      justifyContent: 'space-around',
      alignItems: 'center',
      flexDirection: 'column'
    }}>
      {button && user.roles.includes(ROLES.STUDENT_DEMO) && <Card
        style={{ margin: '16px', maxWidth: '800px' }}
      >
        <Card.Meta title="Améliorer sa syntaxe" />
        <div>
          <br />
          <p>Module 1 : Appréhender et manipuler intuitivement la structure syntaxique d’une phrase.</p>
          <p>L’application commence par proposer un test diagnostique, dont le résultat permet d’orienter vers un parcours personnalisé, avant de vérifier ce qui a été acquis lors d’un test final.</p>
        </div>
      </Card>}
      {button && <Button style={{ marginTop: '56px'}} type="primary" onClick={() => setButton(false)}> Démarrer </Button>}
      {!button && <IA>
        <Activity activityWidth={activityWidth} activityHeight={activityHeight} localActivityId={activityId} />
      </IA>}
    </div>
  );
};

export default Chatbot;